import { graphql } from 'gatsby';
import parse from 'html-react-parser';
import { useId } from 'react';
import { Wrapper, Content } from './Tooltip.styles';
import InfoIcon from './components/InfoIcon';

interface TooltipProps extends Queries.TOOLTIPFragment {
  className?: string;
}

const Tooltip = ({ tooltipElements: { theme, content }, className }: TooltipProps) => {
  const reactId = useId();
  const uniqueId = `tooltip-${reactId.replaceAll(/[^a-zA-Z0-9_-]/g, '')}`;
  const themeValue = theme.value;
  const liCount = (content.value.match(/<li>/g) ?? []).length; // Count the amount of <li>'s to determine the amount of columns
  const ulCount = (content.value.match(/<ul>/g) ?? []).length; // Count the amount of <ul>'s to determine the amount of columns

  return (
    <Wrapper data-tooltip-id={uniqueId} className={className}>
      <InfoIcon theme={themeValue} />
      <Content
        id={uniqueId}
        className={`tooltip theme-${themeValue}`}
        liCount={liCount}
        ulCount={ulCount}
      >
        {parse(content.value)}
      </Content>
    </Wrapper>
  );
};

export const fragment = graphql`
  fragment TOOLTIP on kontent_item_tooltip {
    system {
      id
    }
    tooltipElements: elements {
      theme {
        value
      }
      content {
        value
      }
    }
  }
`;

export default Tooltip;
